@if (sortOptions$ | async; as sortOptions) {
  <div
    [class]="stacked ? 'app-bidlist-sort-select app-bidlist-sort-select--stacked' : 'app-bidlist-sort-select'"
    >
    <label class="app-bidlist-sort-select__label">{{ label }}</label>
    <div class="app-bidlist-sort-select__select" id="sort_by_dropdown" #searchSortSelect>
      <app-dropdown-select
        data-testid="bidlist-sort-select-dropdown"
        [items]="sortOptions.options"
        (click)="updateSort($event.target); sortByFocus('sortBy')"
        [disabledFlag]="disabledFlag"
        [label]="sortOptions.sortByLabel"
        [asMenu]="false"
      ></app-dropdown-select>
    </div>
  </div>
}
